/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP PDF View 개발
 *
 ********************************************************************/
import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import clog from "../../../utils/logUtils";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
/**
 * @brief EHP PDF View 컴포넌트
 * @param -
 * @returns react components
 */
function PdfViewer(props) {
    const pdfUrl = props.file;
    //const windowSize = useWindowSize();
    //const [numPages, setNumPages] = useState(0);
    //const [pageNumber, setPageNumber] = useState(1);
    const windowSize = props.viewerSize;
    const numPages = props.numPages;
    const setNumPages = props.setNumPages;
    const pageNumber = props.pageNumber;
    const setPageNumber = props.setPageNumber;
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }
    clog("IN PDFVIEWER : SIZE : " + JSON.stringify(windowSize));
    return (React.createElement(React.Fragment, null,
        React.createElement(Document
        //file="/static/doc/test.pdf"
        , { 
            //file="/static/doc/test.pdf"
            file: pdfUrl, onLoadSuccess: onDocumentLoadSuccess },
            React.createElement(Page, { width: windowSize.width, height: windowSize.height, pageNumber: pageNumber }))));
}
export default PdfViewer;
function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: 0,
        height: 0
    });
    useEffect(() => {
        if (typeof window !== "undefined") {
            const handleResize = () => {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            window.addEventListener("resize", handleResize);
            handleResize();
            return () => window.removeEventListener("resize", handleResize);
        }
    }, []);
    return windowSize;
}
;
